/* eslint-disable */
<template>
  <div class="brokers-main-wrapper">
    <div class="tab-content">
      <table class="table">
        <thead>
          <tr>
            <th>id</th>
            <th>name</th>
            <th>active</th>
            <!--            <th>count_twice</th>-->
            <!--            <th>contact_name</th>-->
            <!--            <th>contact_skype</th>-->
            <!--            <th>support_email</th>-->
            <!--            <th>min_deposit</th>-->
            <!--            <th>avg_cpa</th>-->
            <!--            <th>regulated</th>-->
            <!--            <th>start_date</th>-->
            <!--            <th>orders_amount</th>-->
            <th class="" v-if="selectedTab === 'ORDERS'">Amount ordered</th>
            <th class="" v-if="selectedTab === 'ORDERS'">Start Day</th>
            <th class="" v-if="selectedTab === 'ORDERS'">
              avg a day by statistics
            </th>
            <th class="" v-if="selectedTab === 'ORDERS'">
              approximately finish day
            </th>
            <th class="" v-if="selectedTab === 'ORDERS'">how much was made</th>
            <th class="" v-if="selectedTab === 'ORDERS'">how much left</th>

            <th class="" v-if="selectedTab === 'FINANCE'">Invoice</th>
            <th class="" v-if="selectedTab === 'FINANCE'">Received</th>
            <th class="" v-if="selectedTab === 'FINANCE'">Currency</th>
            <th class="" v-if="selectedTab === 'FINANCE'">
              Total in the Crm currency ( ILS )
            </th>
            <th class="" v-if="selectedTab === 'FINANCE'">Bank</th>
            <th class="" v-if="selectedTab === 'FINANCE'">Id</th>

            <th v-if="selectedTab === 'QUOTA'">Avg</th>
            <th v-if="selectedTab === 'QUOTA'">
              Rules under avg do not activate
            </th>
            <th v-if="selectedTab === 'QUOTA'">manual</th>
            <th v-if="selectedTab === 'QUOTA'">high priority | low priority</th>

            <th v-if="selectedTab === 'DEAL'">T1 = CPA</th>
            <th v-if="selectedTab === 'DEAL'">T2 = CPA</th>
            <th v-if="selectedTab === 'DEAL'">Countries expected</th>

            <th v-if="selectedTab === 'CAMPAIGN'">bring friend</th>
            <th v-if="selectedTab === 'CAMPAIGN'">email</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(broker, index) in brokers" :key="index">
            <td>{{ broker.id }}</td>
            <td>{{ broker.name }}</td>
            <td>{{ broker.active === 1 ? "Yes" : "No" }}</td>
            <!--          <td>{{broker.count_twice === 1 ? 'Yes': 'No'}}</td>-->
            <!--          <td>{{broker.contact_name}}</td>-->
            <!--          <td>{{broker.contact_skype}}</td>-->
            <!--          <td>{{broker.support_email === null ? 'No Email' : broker.support_email}}</td>-->
            <!--          <td>{{broker.min_deposit}}</td>-->
            <!--          <td>{{broker.avg_cpa}}</td>-->
            <!--          <td>{{broker.regulated}}</td>-->
            <!--          <td>{{broker.start_date}}</td>-->
            <!--          <td>{{broker.orders_amount === null ? 'No Amount' : broker.orders_amount}}</td>-->
            <td class="" v-if="selectedTab === 'ORDERS'">Amount ordered</td>
            <td class="" v-if="selectedTab === 'ORDERS'">Start Day</td>
            <td class="" v-if="selectedTab === 'ORDERS'">
              avg a day by statistics
            </td>
            <td class="" v-if="selectedTab === 'ORDERS'">
              approximately finish day
            </td>
            <td class="" v-if="selectedTab === 'ORDERS'">how much was made</td>
            <td class="" v-if="selectedTab === 'ORDERS'">how much was made</td>

            <td class="" v-if="selectedTab === 'FINANCE'">Invoice</td>
            <td class="" v-if="selectedTab === 'FINANCE'">Received</td>
            <td class="" v-if="selectedTab === 'FINANCE'">Currency</td>
            <td class="" v-if="selectedTab === 'FINANCE'">
              Total in the Crm currency ( ILS )
            </td>
            <td class="" v-if="selectedTab === 'FINANCE'">Bank</td>
            <td class="" v-if="selectedTab === 'FINANCE'">Id</td>

            <td v-if="selectedTab === 'QUOTA'">Avg</td>
            <td v-if="selectedTab === 'QUOTA'">
              Rules under avg do not activate
            </td>
            <td v-if="selectedTab === 'QUOTA'">manual</td>
            <td v-if="selectedTab === 'QUOTA'">high priority | low priority</td>

            <td v-if="selectedTab === 'DEAL'">T1 = CPA</td>
            <td v-if="selectedTab === 'DEAL'">T2 = CPA</td>
            <td v-if="selectedTab === 'DEAL'">Countries expected</td>

            <td v-if="selectedTab === 'CAMPAIGN'">bring friend</td>
            <td v-if="selectedTab === 'CAMPAIGN'">email</td>
          </tr>
        </tbody>
      </table>
    </div>
    <calendars-dashboard
      :query-object="{}"
      :selected-main-tab="'brokers'"
      :show-calendar="true"
    ></calendars-dashboard>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import BrokerModel from "../components/BrokerModel";
import apiClientCreator from "@/helpers/api/request";
import CalendarsDashboard from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/date_range_filtering_dashboard_v4/CalendarsDashboard";

export default {
  name: "BrokersTable.container",
  components: { CalendarsDashboard },
  mounted() {
    this.getBrokersTableData();

    // this.$emit("default_tab");
    // this.$emit("set-page");
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "loading"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"])
  },
  data() {
    return {
      selectedTab: "CAMPAIGN",
      brokers: [],
      brokersData: []
    };
  },

  methods: {
    getBrokersTableData() {
      apiClientCreator("brokers/table")
        .get("")
        .then(res => {
          this.brokersData = res.data.data;
        });
    },
    async getBrokers() {
      let brokers = [];
      this.brokersData.forEach(function(data) {
        brokers.push(new BrokerModel(data));
      });
      this.brokers = brokers;
    }
  },

  watch: {
    brokersData() {
      this.getBrokers();
    }
  }
};
</script>

<style scoped>
.brokers-main-wrapper {
  margin: 1rem 3rem 1rem 3rem;
}
th,
td {
  font-size: 13px;
  text-align: center;
}
th {
  font-weight: 700;
}
</style>
